import { render, staticRenderFns } from "./UploadButton.vue?vue&type=template&id=69b553b1"
import script from "./UploadButton.vue?vue&type=script&lang=ts"
export * from "./UploadButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports